export default __webpack_public_path__ + "static/media/layer10.0782e52f.webp";